import { AuditLog } from 'interfaces/journey';

export const GEOFENCE_ACTION = 'geofence_event';

export const GEOFENCE_RADIUS_METERS = 200;

export const DISTRIBUTION_CENTER_PLACE = 'distributionCenter';

export interface GeofenceEvent {
  eventId: string;
  type: string;
  placeType: string;
  collectionId?: number;
  lat?: number;
  lng?: number;
  occurredAt?: string;
  journeyId: string;
}

const asNumber = (value: unknown): number | undefined => {
  if (value === null || value === undefined || value === '') return undefined;
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : undefined;
};

export const geofenceEventsOf = (
  audits: AuditLog[] | undefined,
  journeyId: string,
  collectionId: number,
): GeofenceEvent[] =>
  (audits ?? [])
    .filter((audit) => audit.action === GEOFENCE_ACTION)
    .map((audit) => {
      const extras = (audit.extras ?? {}) as Record<string, unknown>;
      return {
        eventId: String(extras.eventId ?? ''),
        type: String(extras.type ?? ''),
        placeType: String(extras.placeType ?? ''),
        collectionId: asNumber(extras.collectionId),
        lat: asNumber(extras.lat),
        lng: asNumber(extras.lng),
        occurredAt: extras.occurredAt ? String(extras.occurredAt) : undefined,
        journeyId,
      };
    })
    .filter((event) =>
      event.placeType === DISTRIBUTION_CENTER_PLACE
        ? true
        : event.collectionId === collectionId,
    );
